import { render, staticRenderFns } from "./Replace.vue?vue&type=template&id=1df0b49e&scoped=true&"
import script from "./Replace.vue?vue&type=script&lang=js&"
export * from "./Replace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df0b49e",
  null
  
)

export default component.exports